import React from "react";
import "../styles/ConfirmationModal/ConfirmationModal.css";
import { useTranslation } from "react-i18next";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message, header }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">

                <div className="modal-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 16 16"><path fill="currentColor" d="M13.38 15H2.62c-.56 0-1.07-.28-1.36-.76s-.32-1.06-.07-1.56l.45.22l-.45-.22L6.57 1.89C6.84 1.34 7.39 1 8 1s1.16.34 1.43.89l5.38 10.8c.25.5.22 1.08-.07 1.56s-.8.76-1.36.76ZM8 2c-.23 0-.43.12-.54.33l-5.38 10.8c-.1.19-.09.4.03.59c.11.18.3.29.51.29h10.76c.21 0 .4-.1.51-.29c.11-.18.12-.39.03-.59L8.54 2.33A.59.59 0 0 0 8 2" /><circle cx="8" cy="11" r=".62" fill="currentColor" /><path fill="currentColor" d="M8 9.12c-.28 0-.5-.22-.5-.5v-3c0-.28.22-.5.5-.5s.5.22.5.5v3c0 .28-.22.5-.5.5" /></svg>

                </div>
                <div className="modal-messages">
                    <h2 className="modal-header">{header}</h2>
                    <p className="modal-message">{message}</p>
                </div>
                <div className="modal-buttons">
                    <button
                        type="button"
                        onClick={onClose}
                        className="cancel-btn"
                    >
                        {t('cancel')}
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="confirm-btn"
                    >
                        {t('del-selected')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
